import { ThreeView } from "../View3dWebCad";
import * as THREE from 'three';
import { OBBManager } from "../OBBManager";
import { SceneExtras } from "../sceneExtras";
import { ModelInfo } from "../View3dWebCadModelInfo";
import { command } from "./command";
import * as marietta from '../../../';
import * as pscommand from '../../../../marietta/pixelstreaming/commands';

export class DuplicateObject extends command {

    constructor(private object: THREE.Object3D) {
        super();
    }

    public execute() {

        const userData = this.object.userData;
        this.object.userData = {};
        const copyObject = this.object.clone();
        this.object.userData = userData;

		const size = this.object.userData.obb.obb.getSize( new THREE.Vector3() );
        const position = this.object.getWorldPosition(new THREE.Vector3());
        if (ThreeView.get().ItemDragManager.isWallItem()) {
            const direction = this.object.getWorldDirection(new THREE.Vector3()).clone().normalize();
            const moveVec3 = direction.cross(new THREE.Vector3(0, 1, 0)).normalize().multiplyScalar(size.x / 2);
            copyObject.position.set(position.x + moveVec3.x, position.y + size.y / 4, position.z + moveVec3.z);
        } else {

            const OBBM = new OBBManager(copyObject);
            OBBM.obb.applyMatrix4(copyObject.matrixWorld);

            const cameraPos = ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3());
            const dir = cameraPos.clone().sub(position); // アイテムからカメラへのベクトル

            const yup = new THREE.Vector3(0, 1, 0);
            const vecZ = dir.projectOnPlane(yup).normalize();  // XZ平面に射影
            const vecX = yup.cross(vecZ).normalize();

            const vec = vecX.clone().add(vecZ);     // ４５度方向にベクトルを修正

            const ray = new THREE.Raycaster(OBBM.obb.center, vec);
            const result = OBBM.obb.intersectRay(ray.ray, new THREE.Vector3());

            const p = result.clone().sub(OBBM.obb.center).multiplyScalar(0.5);

            copyObject.position.set(position.x + p.x, position.y + p.y, position.z + p.z);
            // copyObject.position.set(position.x + size.x / 2, position.y, position.z + size.z / 2);
        }

        // 階データをセット
        const floor = `L${marietta.view3d.webcad.WebCadItemManager.getFloorFromPoint(ThreeView.get().wcCameras.camera.me.getWorldPosition(new THREE.Vector3()))}`;
        copyObject.userData.layer = floor;

        copyObject.userData.attribute = userData.attribute;
        const scale = this.object.scale;
        const rotation = this.object.rotation;
        copyObject.scale.set(1, 1, 1);
        copyObject.rotation.set(0, 0, 0);
        copyObject.userData.obb = new OBBManager(copyObject);
        copyObject.scale.set(scale.x, scale.y, scale.z);
        copyObject.rotation.set(rotation.x, rotation.y, rotation.z);

        // 2D連携：アイテム追加情報更新
        const guid = ThreeView.get().add2DItem(copyObject, userData.modelInfo.code);
        // modelInfoを設定
        copyObject.userData.modelInfo = new ModelInfo(userData.modelInfo.type, {code: userData.modelInfo.code});
        ThreeView.get().setModelInfo(copyObject, guid, userData.modelInfo.idthreed, userData.modelInfo.typeExtras, userData.modelInfo.subType);
        // 2D連携：2Dアイテムの情報更新
        ThreeView.get().update2DItem(copyObject);
        // スケール情報を更新
        ThreeView.get().updateScale(copyObject);
        // コピー元が天井に連動していた UB は、置いた所の天井高さにする（3D のモデルの高さも合わせる）
        this.fitUnitBathToCeiling(copyObject, guid, userData.modelInfo.uuid);

        // アイテムをシーンに追加
        ThreeView.get().wcItemmgr.addItemShapes(copyObject);
        // 選択対象に登録
        ThreeView.get().registSelect(copyObject);
        // アイテムの登録
        ThreeView.get().registItem(copyObject);
        // extras更新
        new SceneExtras(ThreeView.get().wcItemmgr.GltfExtras, copyObject).create();
        
        // px連携
        const command = new pscommand.addItem(copyObject);
        ThreeView.get().pscommunication.send(command.object());
    }

    // 複製した UB の高さを、コピー元が天井に連動していれば置いた所の天井高さにする
    private fitUnitBathToCeiling(copyObject: THREE.Object3D, guid: string, sourceGuid: string): void {
        const item: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(guid);
        const source: marietta.webcad.item.MonicaObject = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(sourceGuid);
        if (!item || !source) {
            return;
        }
        const beforeDepth: number = item.itemInfo.depth;
        marietta.webcad.util.UnitBathUtil.fitToCeilingOnCopy(item, source.itemInfo);
        if (item.itemInfo.depth !== beforeDepth) {
            ThreeView.get().fitHeightTo2D(copyObject, item);
        }
    }

}
